"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormControlLabel = _interopRequireDefault(require("../../internals/components/FormControlLabel"));
var _CheckboxWithoutLabel = require("./CheckboxWithoutLabel");
var _CheckboxWithoutLabel2 = require("./CheckboxWithoutLabel.utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CheckboxFormControlLabel = (0, _CheckboxWithoutLabel2.withCheckboxExtraStyles)(_FormControlLabel.default, {
  isCheckboxRootComponent: false
});
var Checkbox = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _props$componentsProp;
  var readOnly = props.readOnly,
    color = props.color,
    indeterminate = props.indeterminate,
    size = props.size;
  return /*#__PURE__*/_react.default.createElement(CheckboxFormControlLabel, _extends({
    ref: ref,
    control: /*#__PURE__*/_react.default.createElement(_CheckboxWithoutLabel.CheckboxWithoutLabelBase, _extends({
      readOnly: readOnly,
      color: color,
      indeterminate: indeterminate,
      size: size
    }, props === null || props === void 0 ? void 0 : (_props$componentsProp = props.componentsProps) === null || _props$componentsProp === void 0 ? void 0 : _props$componentsProp.checkboxBase))
  }, props));
});
var _default = Checkbox;
exports.default = _default;